class CheckInitialSpeedValidationModel {
    constructor(
        private _myDataError: string = "",
        private _isError: boolean = false
    ) {}
    set myDataError(value: string) {
        this._myDataError = value
    }
    get myDataError(): string {
        return this._myDataError
    }
    set isError(value: boolean) {
        this._isError = value;
    }
    get isError(): boolean {
        return this._isError
    }
}
export default CheckInitialSpeedValidationModel